export default __webpack_public_path__ + "static/media/ROX_4718.14dd3f09.jpg";